import { gql } from '@soundxyz/gql-string';
import { styled } from '@components-shared/src/stitches';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment UserActivityDetail on User {
    id
    artist {
      id
    }
    publicAddress
    webappUri
    username
    avatar {
      id
      url
    }
  }
`);

export const AVATAR_SIZE = 48;

export const Container = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 16,
  maxWidth: '100%',
  width: 'fit-content',
});

export const InfoWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  gap: 8,
  minWidth: 0,
});

export const UsernameWrapper = styled('div', {
  display: 'flex',
  gap: 4,
  marginTop: 1,
});

export const Username = styled('h3', {
  fontStyle: 'semibold',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  maxWidth: 'unset',

  '@tabletLandscape': {
    base: 'L',
  },
});
